'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _level = require('../actions/level');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var levels = function levels() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _level.INVALIDATE_LEVELS:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _level.REQUEST_LEVELS:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _level.RECEIVE_LEVELS:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.levels,
                lastUpdated: action.received_at
            });
        case _level.FAILURE_LEVELS:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var levelReducer = (0, _redux.combineReducers)({
    levels: levels
});

exports.default = levelReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/level.js
// module id = 883
// module chunks = 0